// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/get_medical_master.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MedicalMaster } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetMedicalMasterRequest
 */
export class GetMedicalMasterRequest extends Message<GetMedicalMasterRequest> {
  /**
   * Unique identifier for the medical master record
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetMedicalMasterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMedicalMasterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMedicalMasterRequest {
    return new GetMedicalMasterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMedicalMasterRequest {
    return new GetMedicalMasterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMedicalMasterRequest {
    return new GetMedicalMasterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMedicalMasterRequest | PlainMessage<GetMedicalMasterRequest> | undefined, b: GetMedicalMasterRequest | PlainMessage<GetMedicalMasterRequest> | undefined): boolean {
    return proto3.util.equals(GetMedicalMasterRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetMedicalMasterResponse
 */
export class GetMedicalMasterResponse extends Message<GetMedicalMasterResponse> {
  /**
   * The medical master record
   *
   * @generated from field: com.neulink.pharmacy.MedicalMaster medical_master = 1;
   */
  medicalMaster?: MedicalMaster;

  constructor(data?: PartialMessage<GetMedicalMasterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetMedicalMasterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "medical_master", kind: "message", T: MedicalMaster },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMedicalMasterResponse {
    return new GetMedicalMasterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMedicalMasterResponse {
    return new GetMedicalMasterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMedicalMasterResponse {
    return new GetMedicalMasterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMedicalMasterResponse | PlainMessage<GetMedicalMasterResponse> | undefined, b: GetMedicalMasterResponse | PlainMessage<GetMedicalMasterResponse> | undefined): boolean {
    return proto3.util.equals(GetMedicalMasterResponse, a, b);
  }
}

